import React, { useEffect, useState } from 'react'
import styles from "./style.scss"
import { useDispatch, useSelector } from 'react-redux';
import { connect } from 'react-redux';
import DisputeImages from '../../../../pages/order/order-return/raise-return-claim/disputeImagesFlow/DisputeImages';
import OrderAttachments from '../../../../pages/add-edit-product/image-zoom/OrderAttachments';
import toastMessageActions from "jd-library/toastMessageActions";


function mrpProofUpload({deviceData, cur_batch, onUpload = console.warn("batch_proof not handled"), imageProofsError1,imageProofsError2 }) {
    const dispatch = useDispatch();
    const [mrpProofImages, setPrpProofImagesList] = useState([]);
    const [productFrontImages, setProductFrontImages] = useState([]);
    const [errors, updateError] = useState({
        labelProof: "",
        labelProductFrontProof: "",
    });
    const [isMrpProofImagesUploading, updateMrpProofImagesUploading] = useState(false);
    const [isProductFrontProofUploading, updateProductFrontProofUploading] = useState(false);
    const maxFileSize=50;



    const showErrorAsTostMessage=(errMsg)=>{
        if(!errMsg) return

        dispatch(toastMessageActions.showMessage({
            message: errMsg,
            type: 'error',
        }))
    }

    const formatErrorMessage=(errMsg)=>{
        if(errMsg?.includes("Images less than")){
            errMsg=`File Size cannot Exceed ${maxFileSize} MB`
        }
        else if(errMsg?.includes("Unsupported image encoding")){
            errMsg=`Please Upload a Valid File`
        }
        if(errMsg?.includes("Files are Supported")){
            errMsg=`Please upload JPG,PNG & Webp Files Only.`
        }
        return errMsg;
    }

    const onLocalUpload=()=>{
        console.log("mrpProofImages", mrpProofImages,"\t\t productFrontImages",productFrontImages)
        onUpload(mrpProofImages,productFrontImages, cur_batch);
    }

    useEffect(() => {
        onLocalUpload()
    }, [])


    useEffect(() => {
        if(mrpProofImages.length){            
            updateError({labelProductFrontProof: null,labelProof: null });
        }
        onLocalUpload(true)
    }, [mrpProofImages])


    useEffect(() => {
        if(productFrontImages.length){
            updateError({labelProductFrontProof: null,labelProof: null });
        }
        onLocalUpload(true)
    }, [productFrontImages])

    useEffect(() => {
        const imageProofsError=[imageProofsError1,imageProofsError2]
        console.log("imageProofsError",imageProofsError)
        if(imageProofsError?.length==2){
            // updateError((err) => ({ labelProof: imageProofsError[0],labelProductFrontProof: imageProofsError[1],...err}));
            updateError((err) => {
                const errObj={...err}
                if(imageProofsError[0]){
                    errObj.labelProof=imageProofsError[0]
                }
                if(imageProofsError[1]){
                    errObj.labelProductFrontProof=imageProofsError[1]                    
                }
                return errObj
            })

        } else{
            updateError((err) => ({ labelProof: imageProofsError,labelProductFrontProof:imageProofsError}));
        }
    }, [imageProofsError1,imageProofsError2])
    
    return (
        <div className={styles["mrp_proof_upload"]}>
            <p className={styles["upload_instruction"]}>
                Attach Photo Proof of MRP Printed on Product Packaging
            </p>
            <div className={styles["proof_upload"]}>
                <DisputeImages
                    usingNewAPI={true}
                    list={productFrontImages}
                    maxFiles={1}
                    maxSize={maxFileSize}
                    hasError={errors.labelProductFrontProof}
                    isPurchaseImage={false}
                    updateList={list =>setProductFrontImages(list)}
                    updateError={(error, errMsg) => {           
                        errMsg=formatErrorMessage(errMsg)     
                        showErrorAsTostMessage(errMsg)
                        updateError(errors=>{
                            let errObj = { ...errors };
                            errObj.labelProductFrontProof = errMsg;
                            return errObj
                        })
                    }}
                    disableToast={true}
                    swipeableDrawer={shown =>
                        // updateDrawerShown(f)
                        console.log('H')
                    }
                    noImages={errors.labelProductFrontProof ? true : false}
                    uploading={isProductFrontProofUploading}
                    updateUploading={updateMrpProofImagesUploading}
                    updateUp
                    fileType={'image/*'}
                    validTypes={['jpg', 'jpeg', 'png','webp']}
                    customBtn={{
                        btnTxt:<>
                            Upload Photo of<br /> 
                            Front View of Product
                        </>
                    }}
                    imagesErrMsg={"\t"}
                    ignoreMobilOption={true}
                    ignoreMobCss={deviceData?.isMobile}

                />
                <DisputeImages
                    usingNewAPI={true}
                    list={mrpProofImages}
                    maxFiles={1}
                    maxSize={maxFileSize}
                    hasError={errors.labelProof}
                    isPurchaseImage={false}
                    updateList={list => setPrpProofImagesList(list)}
                    updateError={(error, errMsg) => {
                        errMsg=formatErrorMessage(errMsg)
                       
                        showErrorAsTostMessage(errMsg)
                        updateError(errors=>{
                            let errObj = { ...errors };
                            errObj.labelProof = errMsg;
                            return errObj
                        })
                    }}
                    swipeableDrawer={shown =>
                        // updateDrawerShown(f)
                        console.log('H')
                    }
                    noImages={errors.labelProof ? true : false}
                    uploading={isMrpProofImagesUploading}
                    updateUploading={updateProductFrontProofUploading}
                    updateUp
                    disableToast={true}
                    fileType={'image/*'}
                    validTypes={['jpg', 'jpeg', 'png','webp']}
                    customBtn={{
                        btnTxt:<>
                            Upload Photo of<br />
                            MRP Printed on<br />
                            Product
                        </>
                    }}
                    // imagesErrMsg={errors['labelProof']}

                    imagesErrMsg={"\t"}
                    ignoreMobilOption={true}
                    ignoreMobCss={deviceData?.isMobile}
                />
            </div>
            <p className={styles["error_msg"]}>
                {errors['labelProductFrontProof'] || errors['labelProof']}
            </p>
        </div>
    )
}

const mapStateToProps = (state,props) => {
    return {
        deviceData: state.library.deviceData
    }
}

export default React.memo(connect(mapStateToProps)(mrpProofUpload));
